module.exports = __webpack_public_path__ + "static/img/banner4.99d03f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner4.png
// module id = oXVe
// module chunks = 1